import React, { useState, useEffect } from "react";
import { useAuthStore } from "../store/store";
import { useNavigate } from "react-router-dom";
import { NavLink, Outlet } from "react-router-dom";
import {
  GiftIcon,
  CashIcon,
  UserGroupIcon,
  CreditCardIcon,
  CogIcon,
  ChartBarIcon,
  MenuIcon,
  XIcon,
} from "@heroicons/react/outline";

import UserProfile from "./UserProfile"; // Import the UserProfile component

function Sidebar() {
  const { user, logout, authPrivateDataUrl } = useAuthStore();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    authPrivateDataUrl();
    const loggedInStatus = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedInStatus);

    if (!loggedInStatus) {
      authPrivateDataUrl();
      navigate("/login"); // Redirect to login if not logged in
    }
  }, [navigate]);

  if (isLoggedIn === null) {
    return null; // Prevent rendering until authentication status is determined
  }
  let tabs;
  if (user?.accountType === "admin") {
    tabs = [
      {
        name: "Rewards",
        icon: GiftIcon,
        id: "rewards",
        path: "/dashboard/rewards",
      },
      {
        name: "Investments",
        icon: ChartBarIcon,
        id: "investments",
        path: "/dashboard/investments",
      },
      {
        name: "Chart",
        icon: ChartBarIcon,
        id: "chart",
        path: "/dashboard/chart",
      },
      {
        name: "User",
        icon: ChartBarIcon,
        id: "user",
        path: "/dashboard/user",
      },
      {
        name: "Deposit",
        icon: CashIcon,
        id: "deposit",
        path: "/dashboard/deposit",
      },
      // {
      //   name: "Referral",
      //   icon: UserGroupIcon,
      //   id: "referral",
      //   path: "/dashboard/referral",
      // },
      {
        name: "Cashout",
        icon: CreditCardIcon,
        id: "cashout",
        path: "/dashboard/cashout",
      },
      {
        name: "Settings",
        icon: CogIcon,
        id: "settings",
        path: "/dashboard/settings",
      },
    ];
  } else {
    tabs = [
      {
        name: "Rewards",
        icon: GiftIcon,
        id: "rewards",
        path: "/dashboard/rewards",
      },
      {
        name: "Investments",
        icon: ChartBarIcon,
        id: "investments",
        path: "/dashboard/investments",
      },
      {
        name: "Chart",
        icon: ChartBarIcon,
        id: "chart",
        path: "/dashboard/chart",
      },
      {
        name: "Deposit",
        icon: CashIcon,
        id: "deposit",
        path: "/dashboard/deposit",
      },
      // {
      //   name: "Referral",
      //   icon: UserGroupIcon,
      //   id: "referral",
      //   path: "/dashboard/referral",
      // },
      {
        name: "Cashout",
        icon: CreditCardIcon,
        id: "cashout",
        path: "/dashboard/cashout",
      },
      {
        name: "Settings",
        icon: CogIcon,
        id: "settings",
        path: "/dashboard/settings",
      },
    ];
  }

  return (
    <div className="flex flex-col md:flex-row">
      {/* Mobile Menu Button */}
      <div className="md:hidden p-4 bg-gray-800 flex justify-between items-center">
        <h1 className="text-2xl font-light text-gray-400">TradeRockFx</h1>
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="text-gray-400"
        >
          {isSidebarOpen ? (
            <XIcon className="w-6 h-6" />
          ) : (
            <MenuIcon className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Sidebar navigation */}
      <div
        className={`${
          isSidebarOpen ? "block" : "hidden"
        } md:block md:w-64 bg-gray-800 transition-all`}
      >
        {/* User Profile Section */}
        <div className="p-4">
          <UserProfile
            user={{
              firstName: user?.firstName,
              lastName: user?.lastName,
              accountBalance: user?.accountBallance,
            }}
          />
        </div>

        <ul className="flex flex-col py-4">
          {tabs.map((tab) => (
            <li key={tab.id} className="flex flex-row items-center h-12">
              <NavLink
                to={tab.path}
                className={({ isActive }) =>
                  `flex items-center w-full h-full px-4 ml-2 transition-transform ${
                    isActive
                      ? "text-gray-100"
                      : "text-gray-400 hover:translate-x-2"
                  }`
                }
                onClick={() => setIsSidebarOpen(false)}
              >
                <tab.icon className="w-6 h-6" />
                <span className="ml-2 text-sm font-medium">{tab.name}</span>
              </NavLink>
            </li>
          ))}
          <li className="flex flex-row items-center h-12">
            <NavLink
              className={({ isActive }) =>
                `flex items-center w-full h-full px-4 ml-2 transition-transformt text-red-600`
              }
              onClick={() => {
                logout().then(() => navigate("/login"));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                />
              </svg>
              <span className="ml-2 text-sm font-medium">Logout</span>
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Content area */}
      <div className="flex-1 p-6 bg-gray-100">
        <Outlet />
      </div>
    </div>
  );
}

export default Sidebar;
